import React, { useState, useEffect } from 'react';
import './Floatbar.css'; // You can create a separate CSS file for styling
import AchievementBrief from './AchievementBrief';
import ProgressTracker from './ProgressTracker';
import LoginFloatbar from './LoginFloatbar';
import Searchbar from './Searchbar';
import { useGraph } from '../../contexts/GraphContext';
import { useAuth } from '../../contexts/AuthContext';

const Floatbar = ({ showSearchbar = true, showProgressTracker = false }) => {

    const graphData = useGraph();
    const { user } = useAuth();
    const [currentStep, setCurrentStep] = useState(0);

    // TODO: This State should be check within the ProgressTracker component
    useEffect(() => {
        if (user){
            if (graphData.nodes) {
                const learnedNodes = graphData.nodes.filter(node => user.topicStatus.learned.includes(Number(node.topicId)));
                setCurrentStep(learnedNodes.length)
            }
        }
    }, [graphData.nodes, user?.topicStatus]);

    return (
        <div className="floatbar">
            {showSearchbar && (
                <div className="float-container float-container-transparent">
                    <Searchbar />
                </div>
            )}
            {!user && (
                <div className="float-container">
                    <LoginFloatbar />
                </div>
            )}
            {showProgressTracker && (
                <div className="float-container">
                    {graphData.nodes && (
                        <ProgressTracker title={graphData.trackName} type={graphData.graphType} id={graphData.trackId ? graphData.trackId : graphData.pathId} currentStep={currentStep} totalSteps={graphData.nodes.length} />
                    )}
                </div>
            )}
        </div>
    );
};

export default Floatbar;

//<div className="float-container">
//    <AchievementBrief />
//</div>